/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React from 'react';
import { observer } from 'mobx-react';

export default observer(({
    bannerItem, bannerItemLayouts, bannerSectionId, bannerPlatform,
    appConfig, appsSkeletonModel, allAppsModel,
}) => {
    if (bannerItem && bannerItemLayouts) {
        const {
            layoutId,
        } = bannerItem;
        const BannerItemLayout = bannerItemLayouts[layoutId];
        if (BannerItemLayout) {
            return (
                <BannerItemLayout
                    bannerItem={bannerItem}
                    bannerSectionId={bannerSectionId}
                    allAppsModel={allAppsModel}
                    bannerPlatform={bannerPlatform}
                    appConfig={appConfig}
                    appsSkeletonModel={appsSkeletonModel}
                />
            );
        }
    }
    return null;
});
